import { EngagementBuyer } from '../../../slices/marketplace/timeline/models/engagement-buyer.model';
import { MarketplaceOpportunityStatus } from '../../../slices/marketplace/opportunity/models/opportunity-status';
import { EngagementBuyerActionState } from '../../../slices/marketplace/timeline/models/engagement-buyer-action-state.model';

export class MarketplaceOpportunityHelper {
    public static BuyerEngageDate(
        buyer: EngagementBuyer
    ): Date | null {
        if (!buyer || !buyer.actionState || buyer.actionState.length === 0) {
            return null;
        }

        const engagedActions = buyer.actionState.filter(
            (action: EngagementBuyerActionState) =>
                action.buyerStatus === MarketplaceOpportunityStatus.Engaged
        );

        if (engagedActions.length === 0) {
            return null;
        }

        return new Date(
            Math.min(
                ...engagedActions.map((action: EngagementBuyerActionState) =>
                    new Date(action.dateCreated).getTime()
                )
            )
        );
    }
}
